module.exports = __webpack_public_path__ + "img/foclarity-icon.07127f90.png";